import React from 'react';
import { ApptDetailRow, DateRow, EditWithIcon, LocalDateRow, SessionTimer, TextRow } from 'components';
import { formatSeconds, Images } from 'utils';
import { renderAverageRow } from '../trialData/constants';

export const dataCollectionHead = [
    { name: 'apptId', title: 'Appt ID', custom: false, noSearch: true },
    { name: 'sessionDate', title: 'Session Date', custom: false, noSearch: true },
    { name: 'staff', title: 'Staff Member', custom: false, noSearch: true },
    { name: 'duration', title: 'Duration', custom: false, noSearch: true },
    { name: 'status', title: 'Session Status', custom: false, noSearch: true },
    { name: 'action', title: 'Action', width: '100px', custom: false, noSearch: true },
];

export const dataCollectionBody = (afterSuccess) => [
    {
        rowText: (item) =>
            item?.appt?.displayId ? (
                <ApptDetailRow
                    name={item?.appt?.displayId ? item?.appt?.displayId : '--'}
                    id={item?.appt?.id}
                    afterSuccess={afterSuccess}
                />
            ) : (
                '--'
            ),
    },
    { rowText: (item) => <LocalDateRow date={item?.startDate} /> },
    { rowText: (item) => <TextRow name={item?.staff?.name} /> },
    {
        rowText: (item) => (
            <div className="percent-row-box">
                <SessionTimer sessionById={item} convertByText={true} />
                {/*{formatSeconds(item?.totalDuration)}*/}
            </div>
        ),
    },
    { rowText: (item) => <div className="session-status-box">{renderStatus(item?.status)}</div> },
    {
        button: (fn, item) => <EditWithIcon id={'detail-btn'} icon={Images.arrowRight} handleClick={() => fn('detail')} />,
    },
];

const sessionStatusEnums = {
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    PAUSED: 'PAUSED',
};

const renderStatus = (status) => {
    switch (status) {
        case sessionStatusEnums.IN_PROGRESS:
            return <div className="session-in-progress">In Progress</div>;
        case sessionStatusEnums.COMPLETED:
            return <div className="session-is-completed">Completed</div>;
        case sessionStatusEnums.PAUSED:
            return <div className="session-in-paused">Paused</div>;
        default:
            return '--';
    }
};

export const dataCollectionNotYet = {
    height: '250px',
    title: 'You don’t have Sessions yet',
    subTitle: 'Nothing new for now. Enjoy the silence while it lasts',
    image: Images.emptyFolder,
};

export const ACTION_TYPE = 'GET_GOAL_SESSIONS';
